export default {
  props: {
    kind: {
      type: String,
      default: '',
    },
    routeName: {
      type: String,
      default: '',
    },
  },
  computed: {
    classModifier() {
      return {
        'back-button': true,
        [`back-button--${this.kind}`]: this.kind,
      };
    },
  },
  methods: {
    onButtonClick() {
      if (this.routeName) {
        this.$router.push({ name: this.routeName });
      } else {
        this.$router.go(-1);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/generics/back-button/back-button.js